module.exports = __webpack_public_path__ + "img/icon_envelope.4703c299.svg";